export function artworkHeroAnimation() {
    const artwork = $(".artwork-hero");
    const artworkImage = artwork.find(".image-holder img");
    const artworkImageAnimate = artwork.find(".hero-animation .image-box");
    const header = $(".header");
    $(window).on("load", function () {
        artwork.addClass("animated");
        let headerHeight = header.innerHeight();
        let imageLeft = artworkImage.offset().left;
        let imageTop = artworkImage.offset().top;
        let imageWidth = artworkImage.innerWidth();
        let imageHeight = artworkImage.innerHeight();
        artworkImageAnimate.css({
            left: imageLeft,
            top: imageTop - headerHeight,
            width: imageWidth,
            height: imageHeight
        });

    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/artworkHeroAnimation.js